/* ═══════════════════════════════════════════════════════════════
   REVIEW — the Publish self-review's changes (SYNC_PLAN D3).

   OURS must be the blocks the canvas is rendering right now (on a variant
   tab that is the composed variant, not the draft core), so every word
   offset indexes the document on screen. THEIRS is the published version
   composed the same way. The plugin reads the result inverted.
   ═══════════════════════════════════════════════════════════════ */

import { merge3, type Change } from '../../shared/sync';
import type { ContentBlock } from '../../shared/types';

export function walkChanges(onScreen: ContentBlock[], published: ContentBlock[]): Change[] {
  return merge3(onScreen, onScreen, published).filter((c) => c.kind !== 'reconciled');
}
